import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { NavigationPipe } from '../pipes/navigation/navigation.pipe';
import { Path } from '../constants/paths.constant';
import { tap } from 'rxjs';
import { RfpService } from '../services/rfp/rfp.service';
import { RFPFormItemResponse } from '../models/rfp';
import { RFPState } from '../constants/rfpStates.constant';

const isRfpFormRoute = (route: ActivatedRouteSnapshot): boolean =>
  route.url.some(segment => segment.toString() === Path.RFP.FORM);

const isRfpDetailsViewRoute = (route: ActivatedRouteSnapshot): boolean =>
  route.url.some(segment => segment.toString() === Path.RFP.DETAILS);

const navigateToRfpBoard = (
  router: Router,
  navigationPipe: NavigationPipe,
  userType: 'buyer' | 'contractor'
): void => {
  router.navigate([navigationPipe.transform(`${userType}/${Path.RFP.RFP}`)]);
};

export const rfpDetailsResolver: ResolveFn<RFPFormItemResponse | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const navigationPipe = new NavigationPipe();
  const router = inject(Router);
  const rfpId = route.params['rfpId'];
  const userType = route.data['role'];
  const getDetails = inject(RfpService).getRFPById(rfpId);

  if (rfpId) {
    return getDetails.pipe(
      tap(({ rfp }) => {
        if (!rfp) {
          navigateToRfpBoard(router, navigationPipe, userType);
          return;
        }

        const { state } = rfp;
        if (isRfpDetailsViewRoute(route) && state?.name === RFPState.DRAFT) {
          router.navigate([
            '/' +
              navigationPipe.transform(
                `${userType}/${Path.RFP.RFP}/${Path.RFP.FORM}/${rfpId}`
              ),
          ]);
          return;
        } else if (
          isRfpFormRoute(route) &&
          state?.name !== RFPState.DRAFT &&
          state?.name !== RFPState.OPEN_FOR_QUOTATIONS
        ) {
          router.navigate([
            '/' +
              navigationPipe.transform(
                `${userType}/${Path.RFP.RFP}/${Path.RFP.DETAILS}/${rfpId}`
              ),
          ]);
          return;
        }
      })
    );
  } else {
    return undefined;
  }
};
